<template>
	<page>
		<module enable-flex class="report-edit-module">
			<!-- 弹窗式标题栏 -->
			<div class="dialog-title-bar">
				<span class="dialog-title-text">添加{{reportType == 1 ? 'B' : 'C'}}端质检报告</span>
				<a class="dialog-title-close flex-center" @click="navigateTo('quality_list')"><i class="c-icon-cross"></i></a>
			</div>

			<div class="edit-body flex flex-grow">
                <!-- 左侧质检分类导航 -->
                <div class="category-nav">
                    <c-scroll class="nav-list">
                        <!-- 固定第一项：基础信息（仅当有SKU属性时显示） -->
                        <p v-if="hasSku"
                           class="nav-item"
                           :class="{'z-alive': activeGroupIndex == 0}"
                           @click="scrollToGroup(0)"
                        ><span class="nav-bullet"></span>基础信息</p>
                        
                        <!-- 模板分组（索引偏移：有SKU时从1开始） -->
                        <p
                                v-for="(group, i) in releaseTree"
                                :key="group.group_id"
                                class="nav-item"
                                :class="{'z-alive': activeGroupIndex == (hasSku ? i + 1 : i)}"
                                @click="scrollToGroup(hasSku ? i + 1 : i)"
                        ><span class="nav-bullet"></span>{{group.group_name}}</p>
                    </c-scroll>
                </div>

				<!-- 中间质检操作区 -->
				<div class="form-main flex-grow flex-column">
					<!-- 质检产品区 -->
					<div class="product-bar" :style="{'background-image': `url('${require(`@/assets/image/icon_${reportType == 1 ? 'B' : 'C'}.png`)}')`}">
						<!-- <div class="report-type-icon">{{reportType == 1 ? 'B' : 'C'}}</div> -->
						<div class="product-info">
							<p class="product-title">{{productData.category_name || '手机'}}<span class="title-sep">|</span>{{getProductText(productData)}}</p>
							<p class="product-meta">IMEI：{{productData.produce_imei || '-'}}<span class="meta-sep">|</span>背贴码：{{productData.produce_unique_code || '-'}}</p>
						</div>
					</div>

					<c-scroll ref="formScroll" class="form-scroll flex-grow" @scroll="onFormScroll">
						<div class="form-header">
							<div class="form-header-left">
                                <c-title style="font-size: 15px;font-weight: 600">质检内容如下</c-title>
							</div>
							<div class="form-header-actions">
<!--								<c-button color="main" hollow prepend-icon="tf-search" @click="openFactoryInfo">{{hasFactoryInfo ? '查看/重新查询出厂信息' : '查询产品出厂信息'}}</c-button>-->
								<c-button color="main" hollow prepend-icon="tf-edit" @click="openRemark">{{ remark ? '编辑备注' : '添加备注' }}</c-button>
							</div>
						</div>
						<!-- 第一组：基础信息（SKU属性） -->
						<div v-if="hasSku"
						     :ref="'group-0'"
						     class="form-group"
						>
							<span class="form-group-title">1. 基础信息</span>
							<div v-for="attr in skuAttributes" :key="attr.attribute_parent_id" class="field-row" :ref="'field-sku-' + attr.attribute_parent_id">
								<label class="field-label"><i v-if="attr.required">*</i>{{attr.attribute_name}}</label>
								<div class="field-control">
									<!-- 文本类型 -->
									<c-input v-if="attr.attribute_type == 1"
									         :value="skuTextValues[attr.attribute_parent_id] || ''"
									         placeholder="请输入"
									         @input="val => setSkuText(attr.attribute_parent_id, val)">
									</c-input>
									<!-- 数字类型 -->
									<c-input v-else-if="attr.attribute_type == 2"
									         type="stepper"
									         :value="skuTextValues[attr.attribute_parent_id] || ''"
									         :decimal="getAttrDecimal(attr)"
									         placeholder="请输入"
									         @input="val => setSkuText(attr.attribute_parent_id, val)">
									</c-input>
									<!-- 时间类型 -->
									<c-datetime v-else-if="attr.attribute_type == 3"
									            :value="skuTextValues[attr.attribute_parent_id] || ''"
									            :type="parseFormat(attr).type"
									            :format="parseFormat(attr).format"
									            :time-accuracy="parseFormat(attr).timeAccuracy"
									            @input="val => setSkuText(attr.attribute_parent_id, val)">
									</c-datetime>
									<!-- 选项类型：按钮组 -->
									<template v-else-if="attr.attribute_type == 4">
										<span v-for="val in attr.attribute_values" :key="attr.attribute_parent_id + '_' + val.id"
										      class="option-btn"
										      :class="{'z-alive': skuSelections[attr.attribute_parent_id] == val.id}"
										      @click="setSkuOption(attr.attribute_parent_id, val.id)">
											{{val.name}}<i v-if="skuSelections[attr.attribute_parent_id] == val.id" class="opt-check tf"></i>
										</span>
									</template>
									<!-- 附件类型 -->
									<c-upload-file v-else-if="attr.attribute_type == 5"
									               :value="skuTextValues[attr.attribute_parent_id] || ''"
									               type="file"
									               :multiple="getAttrMultiple(attr)"
									               @change="val => setSkuText(attr.attribute_parent_id, val)">
									</c-upload-file>
									<!-- 图片类型 -->
									<c-upload-file v-else-if="attr.attribute_type == 6"
									               :value="skuTextValues[attr.attribute_parent_id] || ''"
									               type="image"
									               media
									               :multiple="getAttrMultiple(attr)"
									               @change="val => setSkuText(attr.attribute_parent_id, val)">
									</c-upload-file>
									<!-- 其他类型：文本输入 -->
									<c-input v-else
									         :value="skuTextValues[attr.attribute_parent_id] || ''"
									         placeholder="请输入"
									         @input="val => setSkuText(attr.attribute_parent_id, val)">
									</c-input>
								</div>
							</div>
						</div>
						<!-- 模板分组（有SKU时索引从1开始） -->
						<div
							v-for="(group, i) in releaseTree"
							:key="group.group_id"
							:ref="'group-' + (hasSku ? i + 1 : i)"
							class="form-group"
						>
							<span class="form-group-title">{{(hasSku ? i + 1 : i) + 1}}. {{group.group_name}}</span>
							<div v-for="item in group.items" :key="item.parent_id" class="field-row" :ref="'field-tpl-' + item.parent_id">
								<label class="field-label"><i v-if="item.is_required != 2">*</i>{{item.parent_name}}<em v-if="item.is_required == 2 && item.mutual_parent_id">与【{{getMutualName(item)}}】互斥</em></label>
								<div class="field-control">
									<!-- 有选项：按钮组 -->
									<template v-if="item.children && item.children.length">
										<span
											v-for="child in item.children"
											:key="item.parent_id + '_' + child.release_id"
											class="option-btn"
											:class="{
												'z-normal': child.selected && !isDefectChild(child), 'z-defect': child.selected && isDefectChild(child),
												's-normal': !isDefectChild(child), 's-defect': isDefectChild(child)
											}"
											@click="setFieldValue(item, child)"
										>{{child.release_name}}<i v-if="child.selected" class="opt-check tf"></i></span>
									</template>
									<!-- 无选项：文本输入 -->
									<c-input
										v-else
										:value="item.input_value || ''"
										placeholder="请选择/输入"
										@input="val => setInputValue(item, val)"
									></c-input>
								</div>
							</div>
						</div>
					</c-scroll>
				</div>

				<!-- 右侧质检选项预览：异常项/正常项/未填写三Tab，默认异常项 -->
				<div class="preview-side">
					<div class="preview-title">质检选项预览</div>
					<div class="preview-tabs">
						<span class="preview-tab" :class="{'z-alive': previewTab == 'defect'}" @click="previewTab = 'defect'">异常项（{{defectItems.length}}）</span>
						<span class="preview-tab" :class="{'z-alive': previewTab == 'normal'}" @click="previewTab = 'normal'">正常项（{{normalItems.length}}）</span>
						<span class="preview-tab" :class="{'z-alive': previewTab == 'unfill'}" @click="previewTab = 'unfill'">未填写（{{unfilledItems.length}}）</span>
					</div>
					<c-scroll class="preview-list">
						<!-- 异常项Tab：瑕疵类质检项（映射信息点击行内“映射”按钮在弹窗中查看） -->
						<template v-if="previewTab == 'defect'">
							<div v-if="!defectItems.length" class="preview-empty">暂无异常项信息</div>
							<div v-for="item in defectItems" :key="item.parent_id" class="preview-item" @click="locatePreviewItem(item)">
								<label>{{item.parent_name}}</label>
								<span :class="{'z-defect': isDefectItem(item)}">{{getSelectedName(item)}}</span>
								<i class="preview-ref-btn" title="查看三方渠道映射配置" @click.stop="openChannelRefConfig(item)">映射</i>
							</div>
						</template>
						<!-- 未填写Tab：尚未填写数值的项目（基础数据 + 模板质检项，按左侧顺序） -->
						<template v-else-if="previewTab == 'unfill'">
							<div v-if="!unfilledItems.length" class="preview-empty">所有质检项均已填写</div>
							<div v-for="item in unfilledItems" :key="item.parent_id" class="preview-item" @click="locatePreviewItem(item)">
								<label>{{item.parent_name || item.name}}</label>
								<span class="z-empty">未填写</span>
							</div>
						</template>
						<!-- 正常项Tab：基础信息 + 非瑕疵类质检项 -->
						<template v-else>
							<div v-if="!normalItems.length" class="preview-empty">暂无正常项信息</div>
							<div v-for="item in normalItems" :key="item.parent_id" class="preview-item" @click="locatePreviewItem(item)">
								<label>{{item.parent_name || item.name}}</label>
								<span :class="{'z-empty': !getSelectedName(item), 'z-normal': getSelectedName(item) && !item.attribute_parent_id && !isDefectItem(item), 'z-defect': !item.attribute_parent_id && isDefectItem(item)}">{{getSelectedName(item) || '未填写'}}</span>
							</div>
						</template>
					</c-scroll>
				</div>
			</div>

			<template #button>
				<c-button size="dialog" color="main" @click="submitHandle">保存质检报告</c-button>
				<c-button size="dialog" @click="navigateTo('quality_list')">取消</c-button>
			</template>
		</module>

		<!-- 查询产品出厂信息弹窗 -->
		<c-dialog ref="factoryDialog" :title="dialogTitle" width="500px" :button="false" @resolve="saveFactoryInfo" height="500px">
			<!-- 模式1：展示已有出厂信息 -->
			<template v-if="dialogMode == 'info'">
				<div class="factory-list">
					<div v-for="item in factoryFieldList" :key="item.key" class="factory-item flex-center-cross">
						<label>{{item.label}}</label>
						<span class="factory-value">{{factoryInfo[item.key] || '-'}}</span>
					</div>
				</div>
				<div class="dialog-footer">
					<c-button size="small" color="main" @click="startRequery">重新查询</c-button>
				</div>
			</template>
			<!-- 模式2：选择查询渠道 -->
			<template v-else-if="dialogMode == 'channels'">
				<p class="channel-tip">请选择查询渠道：</p>
				<div class="channel-list">
					<div
						v-for="ch in channels"
						:key="ch.channelId"
						class="channel-item"
						:class="{'z-alive': selectedChannelId == ch.channelId}"
						@click="selectedChannelId = ch.channelId"
					>
						<span class="channel-name">{{ch.channelName}}</span>
						<span v-if="ch.channelFee" class="channel-fee">费用：{{ch.channelFee}}元</span>
					</div>
				</div>
				<div class="dialog-footer">
					<c-button size="small" color="main" :disabled="!selectedChannelId" @click="doQueryDeviceInfo">开始查询</c-button>
				</div>
			</template>
			<!-- 模式3：查询中 -->
			<template v-else-if="dialogMode == 'loading'">
				<div class="query-loading">
					<span class="loading-spinner"></span>
					<span>正在查询出厂信息...</span>
				</div>
			</template>
			<!-- 模式4：展示查询结果 -->
			<template v-else-if="dialogMode == 'result'">
				<div class="factory-list">
					<div v-for="item in factoryFieldList" :key="item.key" class="factory-item flex-center-cross">
						<label>{{item.label}}</label>
						<c-input :value="factoryInfo[item.key]" @input="val => $set(factoryInfo, item.key, val)"></c-input>
					</div>
				</div>
				<div class="dialog-footer">
					<c-button size="small" @click="startRequery">重新查询</c-button>
				</div>
			</template>
		</c-dialog>

		<!-- 添加备注弹窗 -->
		<c-dialog ref="remarkDialog" :title="remark ? '编辑备注' : '添加备注'" width="420px" button-name="确定">
            <div class="remark-input">
			    <c-input v-model="remark" type="textarea" placeholder="请在这里填写备注..." maxlength="300" :height-resize="{minHeight: '120px'}"></c-input>
            </div>
		</c-dialog>

		<!-- 异常项三方渠道映射配置查看弹窗（spv_channel_ref + tbl_channel_info，展示平台级配置，按报告端业务类型过滤） -->
		<c-dialog ref="channelRefDialog" :title="'三方渠道映射 - ' + (channelRefConfig.release_name || '')" width="560px" height="440px" :button="false" mask-close>
			<div class="ref-config-body">
				<div class="ref-config-item">
					<label>质检项</label>
					<span>{{channelRefConfig.parent_name || '-'}}</span>
				</div>
				<table class="ref-config-table">
					<thead>
						<tr>
							<th>渠道名称</th>
							<th>渠道映射ID</th>
							<th>渠道映射值</th>
						</tr>
					</thead>
					<tbody>
						<tr v-if="!channelRefConfigList.length">
							<td colspan="3" class="ref-config-empty">该异常项暂未配置三方渠道映射</td>
						</tr>
						<tr v-for="(row, i) in channelRefConfigList" :key="'crc_' + row.channel_id + '_' + i">
							<td>{{row.channel_name}}<i v-if="row.status != 1" class="ref-config-off">已禁用</i></td>
							<td>{{row.channel_value || '-'}}</td>
							<td>{{row.channel_value_name || '-'}}</td>
						</tr>
					</tbody>
				</table>
			</div>
		</c-dialog>

		<!-- 检测到型号已更换质检模板：强制二选一（不可关闭，必须选一个） -->
		<div v-if="showTemplateDialog" class="tpl-change-mask">
			<div class="tpl-change-dialog">
				<div class="tpl-change-title">检测到该型号质检模板已更新</div>
				<div class="tpl-change-body">
					<p>该商品所属型号的质检模板已更换，请选择本次编辑使用的模板：</p>
					<p class="tpl-change-line"><span class="tpl-change-label">旧模板</span>{{reportTemplateName || '-'}}</p>
					<p class="tpl-change-line"><span class="tpl-change-label">新模板</span>{{modelTemplateName || '-'}}</p>
					<p class="tpl-change-tip">使用新模板将以最新模板的质检项重新加载，并尽量保留你之前已编辑的选项（新模板中已不存在的项会被移除，其对应的瑕疵图一并清理）。</p>
				</div>
				<div class="tpl-change-footer">
					<c-button @click="keepHistoryTemplate">继续用旧模板</c-button>
					<c-button color="main" @click="chooseLatestTemplate">使用新模板重新编辑</c-button>
				</div>
			</div>
		</div>

		<!-- 历史质检模板已失效：已直接按最新模板加载，仅需告知 -->
		<div v-if="showTemplateMissingDialog" class="tpl-change-mask">
			<div class="tpl-change-dialog">
				<div class="tpl-change-title">历史质检模板已失效</div>
				<div class="tpl-change-body">
					<p>该商品之前使用的质检模板已不存在或已无可用质检项，已自动按型号最新模板{{templateMissingName ? '【' + templateMissingName + '】' : ''}}加载。</p>
					<p class="tpl-change-tip">请基于最新模板重新确认质检内容后再保存。</p>
				</div>
				<div class="tpl-change-footer">
					<c-button color="main" @click="ackTemplateMissing">知道了</c-button>
				</div>
			</div>
		</div>
	</page>
</template>

<script>
	export default {
		data() {
			return {
				product_code_id: '',
				produce_unique_code: '',
				reportType: 1,
				productData: {},
				releaseTree: [],
				factoryInfo: {},
				remark: '',
				activeGroupIndex: 0,
				navScrollLock: false,
				dialogMode: '',
				channels: [],
				queryResult: null,
				queryLoading: false,
				selectedChannelId: null,
				factoryFieldList: [
					{key: 'model', label: '产品型号'},
					{key: 'warranty_end', label: '保修时间截止'},
					{key: 'produce_date', label: '生产时间'},
					{key: 'activate_date', label: '激活时间'},
					{key: 'color', label: '颜色'},
					{key: 'storage', label: '存储容量'},
					{key: 'cpu', label: 'CPU'},
					{key: 'system_version', label: '系统版本'},
					{key: 'network', label: '网络制式'}
				],
                report_id: null,
                template_id: null,
                template_name: '',
                // 模板变更强制二选一：本次进页是否已处理过、是否展示选择遮罩、新旧模板名称
                templatePrompted: false,
                showTemplateDialog: false,
                reportTemplateName: '',
                modelTemplateName: '',
                // 历史模板已失效：直接按最新模板加载后的提示遮罩与最新模板名
                showTemplateMissingDialog: false,
                templateMissingName: '',
                // SKU属性相关
                skuAttributes: [],
                skuSelections: {},
                skuTextValues: {},
                // 预览面板：当前Tab（defect=异常项，normal=正常项，unfill=未填写，默认异常项）
                previewTab: 'defect',
                // 异常项三方映射配置弹窗：当前查看的异常项信息 + 已加载的映射配置列表（spv_channel_ref + tbl_channel_info）
                channelRefConfig: {release_id: null, release_name: '', parent_name: ''},
                channelRefConfigList: [],
			}
		},

		computed: {
			// 是否已有出厂信息
			hasFactoryInfo() {
				return this.factoryInfo && Object.keys(this.factoryInfo).length > 0;
			},
			// 是否有SKU属性
			hasSku() {
				return this.skuAttributes && this.skuAttributes.length > 0;
			},
			// 分组总数（含基础信息组）
			groupCount() {
				return (this.hasSku ? 1 : 0) + this.releaseTree.length;
			},
			// 弹窗标题
			dialogTitle() {
				var titles = {info: '产品出厂信息', channels: '选择查询渠道', loading: '查询中', result: '查询结果'};
				return titles[this.dialogMode] || '查询产品出厂信息';
			},
			// 所有质检项（用于预览）
			allItems() {
				var items = [];
				// SKU属性项
				this.skuAttributes.forEach(attr => {
					items.push(Object.assign({}, attr, {
						parent_id: 'sku_' + attr.attribute_parent_id,
						parent_name: attr.attribute_name
					}));
				});
				// 模板分组项
				this.releaseTree.forEach(group => {
					(group.items || []).forEach(item => {
						if (item.children && item.children.length) {
							items.push(item);
						} else {
							// 输入型质检项：直接引用原对象，保证填写 input_value 后预览实时刷新
							items.push(item);
						}
					});
				});
				return items;
			},
			// 异常项Tab数据：按左侧质检项顺序，仅当前选中瑕疵值（release_type=2）的模板质检项
			defectItems() {
				return this.allItems.filter(item => this.isDefectItem(item));
			},
			// 正常项Tab数据：按左侧质检项顺序，基础数据（无论是否有值）+ 未选中瑕疵值的质检项（含输入型）
			normalItems() {
				return this.allItems.filter(item => !this.isDefectItem(item));
			},
			// 未填写Tab数据：按左侧质检项顺序，尚未填写数值的项目（基础数据未填 + 模板质检项未选值 + 输入型未填）
			unfilledItems() {
				return this.allItems.filter(item => !this.getSelectedName(item));
			}
		},

		mounted() {
			var query = this.$route.query || {};
			this.product_code_id = query.product_code_id || '';
			this.produce_unique_code = query.produce_unique_code || '';
			this.reportType = query.report_type || 1;
			this.loadProduct();
		},

		beforeDestroy() {
			clearTimeout(this.navScrollTimer);
		},

		methods: {
			/*********获取产品信息文字**********/
			getProductText(data) {
				var parts = [];
				if (data.brand_name) parts.push(data.brand_name);
				if (data.model_name) parts.push(data.model_name);
				if (data.color_name) parts.push(data.color_name);
				if (data.memory_name) parts.push(data.memory_name);
				return parts.join(' ') || '-';
			},

			/*********加载商品信息**********/
			loadProduct() {
				var code = this.produce_unique_code;
				if (!code) return;
				this.request({
					url: '/quality/product/queryByCode',
					data: {produce_unique_code: code},
					success: (data) => {
						this.productData = data;
                        if(data && data.factory_info_json){
                            this.factoryInfo = JSON.parse(data.factory_info_json);
                        }
						this.loadTemplateConfig();
					}
				});
			},

			/*********加载质检模板配置**********/
			// source: 'history'(默认，报告历史模板) | 'latest'(型号当前模板)；首次进入不传即 history
			loadTemplateConfig(source) {
				var productCodeId = this.product_code_id;
				if (!productCodeId) return;
				this.request({
					url: '/quality/template/config',
					data: {
						product_code_id: productCodeId,
						report_type: this.reportType,
						template_source: source || 'history'
					},
					loading: true,
					success: (data) => {
						if (!data || !data.groups) return;
						this.report_id = data.report_id || null;
						this.template_id = data.template_id;
						this.template_name = data.template_name;
						// 质检项默认选中：必填与非必填均默认第一项，非必填项存在已选中的互斥项时跳过
						this.applyDefaultSelections(data.groups);
						this.releaseTree = data.groups;

						// 提取SKU属性，基础信息按「本报告已存值 > 初检数据 > B端已维护值 > 选项第一项」回填
						this.skuAttributes = data.sku_attributes || [];
						this.skuSelections = {};
						this.skuTextValues = {};
						this.initSkuValues(data);

						// 历史模板已失效（渲染不出内容）：后端已直接按型号最新模板加载，这里只需提示，不再二选一
						if (!this.templatePrompted && data.template_missing) {
							this.templatePrompted = true;
							this.templateMissingName = data.model_template_name || '';
							this.showTemplateMissingDialog = true;
						} else if (!this.templatePrompted && data.template_changed) {
							// 检测到型号已更换质检模板：首次进入强制二选一，选一次后不再重复弹
							this.templatePrompted = true;
							this.reportTemplateName = data.report_template_name || '';
							this.modelTemplateName = data.model_template_name || '';
							this.showTemplateDialog = true;
						}
					}
				});
			},

			/*********质检项默认选中：必填项必选第一项；非必填项也默认第一项，但其互斥项已选择/填写时跳过**********/
			applyDefaultSelections(groups) {
				// 先处理必填项：非必填项的互斥判断依赖必填项的选中结果，顺序反了会双方同时选中
				groups.forEach(group => {
					(group.items || []).forEach(item => {
						if (item.is_required == 2) return;
						if (!item.children || !item.children.length) return;
						if (item.children.find(c => c.selected)) return;
						item.children[0].selected = true;
					});
				});
				// 再处理非必填项：互斥项已选择/填写时保持未选中，避免自动选中后立即触发互斥限制
				groups.forEach(group => {
					(group.items || []).forEach(item => {
						if (item.is_required != 2) return;
						if (!item.children || !item.children.length) return;
						if (item.children.find(c => c.selected)) return;
						if (this.isMutualFilledIn(groups, item)) return;
						item.children[0].selected = true;
					});
				});
			},

			/*********按传入分组判断互斥项是否已选择/填写（初始化阶段 releaseTree 尚未赋值，不能复用 isMutualFilled）**********/
			isMutualFilledIn(groups, item) {
				if (!item.mutual_parent_id) return false;
				for (var g = 0; g < groups.length; g++) {
					var items = groups[g].items || [];
					for (var j = 0; j < items.length; j++) {
						if (items[j].parent_id != item.mutual_parent_id) continue;
						var mutual = items[j];
						if (mutual.children && mutual.children.length) {
							return !!mutual.children.find(c => c.selected);
						}
						return !!(mutual.input_value && String(mutual.input_value).trim());
					}
				}
				return false;
			},

			/*********基础信息（SKU属性）回填：本报告已存值 > 初检数据 > B端已维护值 > 选项第一项**********/
			initSkuValues(data) {
				// B端已维护值仅用于C端首次维护报告（保持原有口径）
				var bSku = (!this.report_id && this.reportType == 2) ? (data.b_sku_selected || {}) : {};
				var initialSku = data.initial_sku_selected || {};
				this.skuAttributes.forEach(attr => {
					var pid = attr.attribute_parent_id;
					if (attr.attribute_type == 4) {
						var stored = (attr.attribute_values || []).find(v => v.selected);
						var optionId = stored ? stored.id : null;
						if (!optionId) optionId = this.matchSkuOptionId(attr, initialSku[pid]);
						if (!optionId) optionId = this.matchSkuOptionId(attr, bSku[pid]);
						// 初检无可回填数据：默认选中第一项（如果是颜色、或 内存，则无数据时不默认选中）
						if (!optionId && attr.attribute_values && attr.attribute_values.length && pid!=8001 && pid!=8002) optionId = attr.attribute_values[0].id;
						if (optionId) this.$set(this.skuSelections, pid, optionId);
					} else {
						// 文本/数字/日期等属性无默认值可取：按已存值→初检值→B端值依次回填，都无则留空
						var textValue = attr.selected_value || this.getSkuAttrText(initialSku[pid]) || this.getSkuAttrText(bSku[pid]);
						if (textValue) this.$set(this.skuTextValues, pid, textValue);
					}
				});
			},

			/*********初检/历史属性值匹配当前属性选项（选项按属性值ID对应，找不到即视为无回填数据）**********/
			matchSkuOptionId(attr, attrValue) {
				if (!attrValue || attrValue.attribute_id == null) return null;
				var matched = (attr.attribute_values || []).find(v => v.id == attrValue.attribute_id);
				return matched ? matched.id : null;
			},

			/*********取属性JSON中的文本值（文本/数字/日期类属性）**********/
			getSkuAttrText(attrValue) {
				if (!attrValue || attrValue.attribute_value == null) return '';
				return String(attrValue.attribute_value);
			},

			/*********模板失效提示：知道了**********/
			ackTemplateMissing() {
				this.showTemplateMissingDialog = false;
			},

			/*********模板变更二选一：改用新模板重新加载**********/
			chooseLatestTemplate() {
				this.showTemplateDialog = false;
				this.loadTemplateConfig('latest');
			},

			/*********模板变更二选一：继续用旧模板**********/
			keepHistoryTemplate() {
				this.showTemplateDialog = false;
			},

			/*********设置选项字段值**********/
			setFieldValue(item, child) {
				// 非必填质检项：点击已选中的选项时允许取消选中（取消不受互斥限制）
				if (item.is_required == 2 && child.selected) {
					this.$set(child, 'selected', false);
					return;
				}
				// 互斥质检项：互斥对方已选择/填写时不再允许选择本项（需先取消对方的选择）
				if (this.isMutualFilled(item)) {
					this.$message({message: '【' + item.parent_name + '】与【' + this.getMutualName(item) + '】互斥，请先取消【' + this.getMutualName(item) + '】的选择', type: 'warn'});
					return;
				}
				(item.children || []).forEach(c => { this.$set(c, 'selected', false); });
				this.$set(child, 'selected', true);
			},
			
			/*********设置文本输入字段值**********/
			setInputValue(item, value) {
				this.$set(item, 'input_value', value);
			},
			
			/*********设置SKU选项选中**********/
			setSkuOption(parentId, valueId) {
				this.$set(this.skuSelections, parentId, valueId);
			},
			
			/*********设置SKU文本输入**********/
			setSkuText(parentId, value) {
				this.$set(this.skuTextValues, parentId, value);
			},

			/*********解析SKU属性config_json格式配置**********/
			parseFormat(attr) {
				var config = attr.config_json || {};
				if (config.format) {
					var parts = config.format.split('|');
					return { format: parts[0] || 'yyyy-MM-dd', type: parts[1] || 'date', timeAccuracy: parts[2] || '' };
				}
				return { format: 'yyyy-MM-dd', type: 'date', timeAccuracy: '' };
			},

			/*********获取SKU数字属性小数位**********/
			getAttrDecimal(attr) {
				var config = attr.config_json || {};
				return config.decimal !== undefined ? config.decimal : 0;
			},

			/*********获取SKU上传属性是否多选**********/
			getAttrMultiple(attr) {
				var config = attr.config_json || {};
				return config.multiple ? 30 : false;
			},

			/*********判断子项是否为瑕疵项**********/
			isDefectChild(child) {
				return child.release_type == 2;
			},

			/*********判断预览项是否为瑕疵项（基础信息不参与颜色区分）**********/
			isDefectItem(item) {
				if (item.attribute_parent_id) return false;
				if (item.children && item.children.length) {
					var selected = item.children.find(c => c.selected);
					return !!(selected && selected.release_type == 2);
				}
				return false;
			},

			/*********查找互斥质检项（互斥项配置在同分组，按ID全树查找兜底）**********/
			getMutualItem(item) {
				if (!item.mutual_parent_id) return null;
				for (var g = 0; g < this.releaseTree.length; g++) {
					var items = this.releaseTree[g].items || [];
					for (var j = 0; j < items.length; j++) {
						if (items[j].parent_id == item.mutual_parent_id) return items[j];
					}
				}
				return null;
			},

			/*********互斥质检项显示名称（后端未带出名称时按ID反查）**********/
			getMutualName(item) {
				if (item.mutual_parent_name) return item.mutual_parent_name;
				var mutual = this.getMutualItem(item);
				return mutual ? mutual.parent_name : '互斥项';
			},

			/*********互斥质检项是否已选择/填写（选择型看选中，输入型看填写内容）**********/
			isMutualFilled(item) {
				var mutual = this.getMutualItem(item);
				if (!mutual) return false;
				return this.isItemFilled(mutual);
			},

			/*********质检项是否已选择/填写**********/
			isItemFilled(item) {
				if (item.children && item.children.length) {
					return !!item.children.find(c => c.selected);
				}
				return !!(item.input_value && String(item.input_value).trim());
			},

			/*********打开异常项三方渠道映射配置弹窗（spv_channel_ref + tbl_channel_info）**********/
			openChannelRefConfig(item) {
				var selected = (item.children || []).find(c => c.selected);
				if (!selected) return;
				this.channelRefConfig = {
					release_id: selected.release_id,
					release_name: selected.release_name,
					parent_name: item.parent_name
				};
				this.channelRefConfigList = [];
				this.$refs.channelRefDialog.open();
				this.loadChannelRefConfig(selected.release_id);
			},

			/*********加载异常项三方渠道映射配置（平台级配置，不按商户绑定渠道过滤；biz_type按报告端ToB/ToC过滤渠道）**********/
			loadChannelRefConfig(releaseId) {
				this.request({
					url: '/quality/report/channel/ref/config',
					data: {
						release_id: releaseId,
						// 业务类型与报告端一致：reportType 1=B端(2B)、2=C端(2C)，正好对应 tbl_channel_info.biz_type
						biz_type: this.reportType
					},
					loading: true,
					success: (data) => {
						this.channelRefConfigList = data || [];
					}
				});
			},

			/*********获取字段显示值（预览用）**********/
			getSelectedName(item) {
				// SKU选项类型
				if (item.attribute_values && item.attribute_values.length) {
					var selectedId = this.skuSelections[item.attribute_parent_id];
					var found = (item.attribute_values || []).find(v => v.id == selectedId);
					return found ? found.name : '';
				}
				// SKU文本类型
				if (item.attribute_parent_id && item.attribute_type != 4) {
					return this.skuTextValues[item.attribute_parent_id] || '';
				}
				// 原有模板项逻辑
				if (item.children && item.children.length) {
					var selected = item.children.find(c => c.selected);
					return selected ? selected.release_name : '';
				}
				return item.input_value || '';
			},

			/*********获取分组元素（v-if基础信息组为单元素，v-for分组ref为数组）**********/
			getGroupEl(index) {
				var ref = this.$refs['group-' + index];
				if (!ref) return null;
				return Array.isArray(ref) ? ref[0] : ref;
			},

			/*********点击预览项定位到左侧对应填写位置**********/
			locatePreviewItem(item) {
				// 行键与表单 field-row 的 ref 对应：SKU基础信息用 field-sku-前缀，模板质检项用 field-tpl-前缀
				var refName = item.attribute_parent_id ? ('field-sku-' + item.attribute_parent_id) : ('field-tpl-' + item.parent_id);
				var ref = this.$refs[refName];
				var el = Array.isArray(ref) ? ref[0] : ref;
				if (!el) return;
				// 同步左侧导航选中：SKU基础信息=第0组；模板质检项按所在分组换算（有SKU时索引偏移1）
				var navIndex = 0;
				if (!item.attribute_parent_id) {
					var gi = this.releaseTree.findIndex(group => (group.items || []).some(it => it === item));
					if (gi < 0) return;
					navIndex = this.hasSku ? gi + 1 : gi;
				}
				this.activeGroupIndex = navIndex;
				// 平滑滚动期间锁定滚动监听，避免途经分组时左侧导航来回跳动
				this.navScrollLock = true;
				clearTimeout(this.navScrollTimer);
				el.scrollIntoView({behavior: 'smooth', block: 'center'});
				this.navScrollTimer = setTimeout(() => {
					this.navScrollLock = false;
				}, 700);
			},

			/*********滚动到指定分类**********/
			scrollToGroup(navIndex) {
				this.activeGroupIndex = navIndex;
				// 导航索引与表单分组索引一致（有SKU时导航0=表单0，导航1=表单1...）
				var el = this.getGroupEl(navIndex);
				if (el) {
					// 平滑滚动期间锁定滚动监听，避免选中项经过中间分组时来回跳动
					this.navScrollLock = true;
					clearTimeout(this.navScrollTimer);
					el.scrollIntoView({behavior: 'smooth', block: 'start'});
					this.navScrollTimer = setTimeout(() => {
						this.navScrollLock = false;
					}, 700);
				}
			},

			/*********表单滚动时同步左侧导航选中项**********/
			onFormScroll() {
				if (this.navScrollLock) return;
				var scroller = this.$refs.formScroll && this.$refs.formScroll._scroller;
				if (!scroller || !this.groupCount) return;
				// 判定线：分组标题滚动到距容器顶部120px内时视为当前分组
				var line = scroller.getBoundingClientRect().top + 120;
				var active = 0;
				for (var i = 0; i < this.groupCount; i++) {
					var el = this.getGroupEl(i);
					if (el && el.getBoundingClientRect().top <= line) active = i;
				}
				// 已滚动到底部时选中最后一组（末尾分组内容不足一屏时无法滚到顶部）
				if (scroller.scrollTop + scroller.clientHeight >= scroller.scrollHeight - 10) {
					active = this.groupCount - 1;
				}
				this.activeGroupIndex = active;
			},

			/*********打开出厂信息弹窗**********/
			openFactoryInfo() {
				if (this.hasFactoryInfo) {
					this.dialogMode = 'info';
				} else {
					this.loadChannels();
				}
				this.$refs.factoryDialog.open();
			},

			/*********加载查询渠道**********/
			loadChannels() {
				this.dialogMode = 'channels';
				this.selectedChannelId = null;
				this.request({
					url: '/imei/query-channels',
					success: (data) => {
						this.channels = data || [];
					}
				});
			},

			/*********重新查询（回到渠道选择）**********/
			startRequery() {
				this.loadChannels();
			},

			/*********执行设备信息查询**********/
			doQueryDeviceInfo() {
				if (!this.selectedChannelId) return;
				var imei = this.productData.produce_imei;
				if (!imei) {
					this.$message({message: '商品IMEI为空，无法查询', type: 'warn'});
					return;
				}
				this.dialogMode = 'loading';
				this.request({
					url: '/imei/query-device-info',
					data: {
						channelId: this.selectedChannelId,
						imei: imei
					},
					success: (data) => {
						this.queryResult = data;
						this.mapApiToFactoryInfo(data);
						this.dialogMode = 'result';
					},
					error: () => {
						this.dialogMode = 'channels';
					}
				});
			},

			/*********将API返回数据映射到出厂信息**********/
			mapApiToFactoryInfo(data) {
				if (!data) return;
				this.$set(this.factoryInfo, 'model', data.modelName || '');
				this.$set(this.factoryInfo, 'warranty_end', data.warrantyEndTime || '');
				this.$set(this.factoryInfo, 'produce_date', data.manufacturingDate || '');
				this.$set(this.factoryInfo, 'activate_date', data.activatedTime || '');
				this.$set(this.factoryInfo, 'color', data.color || '');
				this.$set(this.factoryInfo, 'storage', data.capacity || '');
				this.$set(this.factoryInfo, 'cpu', '');
				this.$set(this.factoryInfo, 'system_version', '');
				this.$set(this.factoryInfo, 'network', data.modelNumber || '');
			},

			/*********保存出厂信息**********/
			saveFactoryInfo() {
				this.$message({message: '出厂信息已记录', type: 'success'});
			},

			/*********打开备注弹窗**********/
			openRemark() {
				this.remarkDraft = this.remark;
				this.$refs.remarkDialog.open();
			},

			/*********确认备注**********/
			confirmRemark() {
				this.remark = this.remarkDraft;
				this.$refs.remarkDialog.close();
			},

			/*********构建质检结果JSON（仅模板质检项，SKU基础信息不存入报告，通过sku_attribute_values单独存储）**********/
			buildResultJson() {
				var groups = [];

				// 模板分组
				this.releaseTree.forEach(group => {
					var groupObj = {
						group_id: group.group_id,
						group_name: group.group_name,
						items: []
					};
					(group.items || []).forEach(item => {
						var itemObj = {
							parent_id: item.parent_id,
							parent_name: item.parent_name,
							children: []
						};
						if (item.children && item.children.length) {
							item.children.forEach(child => {
								itemObj.children.push({
									release_id: child.release_id,
									release_name: child.release_name,
									release_type: child.release_type || 1,
									selected: !!child.selected
								});
							});
						} else {
							// 输入型质检项：release_id 固定 -1，release_name 存用户填写的文本
							itemObj.children.push({
								release_id: -1,
								release_name: item.input_value || '',
								selected: !!item.input_value
							});
						}
						groupObj.items.push(itemObj);
					});
					groups.push(groupObj);
				});
				return JSON.stringify({groups: groups});
			},

			/*********提交保存**********/
			submitHandle() {
				var productCodeId = this.productData.product_code_id;
				if (!productCodeId) {
					this.$message({message: '商品信息缺失', type: 'warn'});
					return;
				}

				// 校验必填SKU字段
				for (var i = 0; i < this.skuAttributes.length; i++) {
					var attr = this.skuAttributes[i];
					if (!attr.required) continue;
					if (attr.attribute_type == 4) {
						if (!this.skuSelections[attr.attribute_parent_id]) {
							this.$message({message: '请选择' + attr.attribute_name, type: 'warn'});
							return;
						}
					} else {
						if (!this.skuTextValues[attr.attribute_parent_id]) {
							this.$message({message: '请填写' + attr.attribute_name, type: 'warn'});
							return;
						}
					}
				}

				// 校验必填质检项：选择型必须选中一个值、输入型必须填写文本（非必填项 is_required=2 跳过）
				for (var g = 0; g < this.releaseTree.length; g++) {
					var groupItems = this.releaseTree[g].items || [];
					for (var j = 0; j < groupItems.length; j++) {
						var it = groupItems[j];
						if (it.is_required == 2) continue;
						if (it.children && it.children.length) {
							if (!it.children.find(c => c.selected)) {
								this.$message({message: '请选择' + it.parent_name, type: 'warn'});
								return;
							}
						} else {
							if (!it.input_value || !String(it.input_value).trim()) {
								this.$message({message: '请填写' + it.parent_name, type: 'warn'});
								return;
							}
						}
					}
				}

				// 校验互斥质检项：互斥双方不允许同时选择/填写（选择时已阻止，此处兜底存量数据与输入型）
				for (var g2 = 0; g2 < this.releaseTree.length; g2++) {
					var mutualItems = this.releaseTree[g2].items || [];
					for (var j2 = 0; j2 < mutualItems.length; j2++) {
						var mIt = mutualItems[j2];
						if (!mIt.mutual_parent_id) continue;
						if (this.isItemFilled(mIt) && this.isMutualFilled(mIt)) {
							this.$message({message: '【' + mIt.parent_name + '】与【' + this.getMutualName(mIt) + '】互斥，两者只能选择其一', type: 'warn'});
							return;
						}
					}
				}

				var skuAttributeValues = {};
				this.skuAttributes.forEach(attr => {
					if (attr.attribute_type == 4) {
						var val = this.skuSelections[attr.attribute_parent_id];
						if (val) skuAttributeValues[attr.attribute_parent_id] = val;
					} else {
						var textVal = this.skuTextValues[attr.attribute_parent_id];
						if (textVal) skuAttributeValues[attr.attribute_parent_id] = textVal;
					}
				});

				var data = {
                    id: this.report_id,
                    template_id: this.template_id,
					product_code_id: productCodeId,
					report_type: this.reportType,
					result_json: this.buildResultJson(),
					remark: this.remark,
					sku_attribute_values: JSON.stringify(skuAttributeValues)
				};

				this.request({
					url: this.report_id ? '/quality/report/update' : '/quality/report/add',
					data: data,
					loading: true,
					success: (res, msg) => {
						this.$message({message: msg, type: 'success'});
						this.navigateTo('quality_list');
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
.remark-input
    padding 20px

.tpl-change-mask
	position fixed
	left 0
	top 0
	right 0
	bottom 0
	background rgba(0, 0, 0, .5)
	z-index 2000
	display flex
	align-items center
	justify-content center
	.tpl-change-dialog
		width 460px
		background #fff
		border-radius 8px
		overflow hidden
		box-shadow 0 8px 30px rgba(0, 0, 0, .18)
		.tpl-change-title
			padding 18px 24px
			font-size 16px
			font-weight 600
			color #1a1a1a
			border-bottom 1px solid #eef0f5
		.tpl-change-body
			padding 20px 24px
			font-size 13px
			color #4a5568
			line-height 22px
			p
				margin 0 0 10px
			.tpl-change-line
				color #1a1a1a
				.tpl-change-label
					display inline-block
					width 56px
					color #8a94a6
			.tpl-change-tip
				margin 0
				color #8a94a6
				font-size 12px
		.tpl-change-footer
			display flex
			justify-content flex-end
			gap 12px
			padding 14px 24px
			border-top 1px solid #eef0f5

.report-edit-module
	background #fff
.dialog-title-bar
	display flex
	align-items center
	justify-content space-between
	padding 0 20px 0 30px
	background #fff
	border-bottom 1px solid #e8ebf0
	height 54px
	.dialog-title-text
		font-size 18px
		font-weight 600
		color #1a1a1a
	.dialog-title-close
		width 40px
		height 40px
		font-size 18px
		color #999
	    transition all .3s ease

		&:hover {
			color red
		}
	.dialog-title-actions
		display flex
		align-items center
		gap 16px
		.title-action-icon
			font-size 16px
			color #8a94a6
			cursor pointer
			transition color .2s
			&:hover
				color #1890ff
.edit-body
	overflow hidden
	background #fff
	.category-nav
		width 220px
		flex-shrink 0
		background #fff
		overflow hidden
		padding 30px 0
		border-right 1px solid #edf0f5
		.nav-list
			height 100%
			padding 8px 0
			.nav-item
				display flex
				align-items center
				padding 11px 30px
				font-size 14px
				color #8a94a6
				cursor pointer
				transition all .2s
				.nav-bullet
					display inline-block
					width 4px
					height 4px
					border 1px solid #c5d0dc
					margin-right 10px
					flex-shrink 0
					transition all .2s
				&:hover
					color #4a5568
				&.z-alive
					color #3D5EFF
					font-weight 600
					.nav-bullet
						border-color #3D5EFF
						background #3D5EFF
	.form-main
		min-width 0
		background #fff
		border-right 1px solid #edf0f5
		.product-bar
			display flex
			align-items center
			background #F0F3FF
			height 70px
			background-repeat: no-repeat;
			background-size: auto 66px;
			background-position: left 20px top 4px;
			.report-type-icon
				width 46px
				height 46px
				line-height 46px
				text-align center
				font-size 22px
				font-weight bold
				color #fff
				background linear-gradient(135deg, #1890ff 0%, #096dd9 100%)
				border-radius 10px
				flex-shrink 0
				margin-left 20px
				box-shadow 0 3px 8px rgba(24, 144, 255, .3)
				letter-spacing -1px
			.product-info
				flex 1
				text-align center
				.product-title
					margin 0 0 10px
					font-size 16px
					font-weight 600
					color #3D5EFF
					.title-sep
						margin 0 10px
				.product-meta
					margin 0
					font-size 13px
					color #7a8ea0
					.meta-sep
						margin 0 10px
						color #d0dce6
		.form-scroll
			padding 0
		.form-header
			display flex
			align-items center
			justify-content space-between
			padding 14px 24px
			.form-header-left
				display flex
				align-items center
			.form-header-icon
				font-size 18px
				margin-right 8px
			.form-header-text
				font-size 16px
				font-weight 600
				color #1d3557
			.form-header-actions
				display flex
				gap 10px
				flex-shrink 0
		.form-group
			padding 16px 16px
			margin 0 16px 20px
			border-radius 5px
			background linear-gradient(180deg, #f5f7ff 0%, #ffffff 40%, #ffffff 100%)
			&:last-child
				margin-bottom 0
			> .c-title
				margin 0 0 16px
				font-size 14px
				font-weight 600
				color #1d3557
				padding-bottom 8px
				border-bottom 1px solid #f5f7fa
			.form-group-title
				display block
				margin 0 0 12px
				font-size 15px
				font-weight 600
				color #1a1a1a
			.field-row
				display flex
				align-items flex-start
				padding 8px 0
				border-radius 4px
				.field-label
					flex-shrink 0
					width 120px
					line-height 36px
					font-size 13px
					color #4a5568
					i
						margin-right 2px
						font-style normal
						color #e53e3e
					// 互斥质检项提示（标签右侧橙色小字）
					em
						margin-left 4px
						font-size 11px
						font-style normal
						color #fa8c16
				.field-control
					flex 1
					display flex
					flex-wrap wrap
					gap 8px
					.option-btn
						position relative
						padding 10px 16px
						border 1px solid #F5F5F5
						border-radius 4px
						font-size 13px
						color #4a5568
						background #F5F5F5
						cursor pointer
						overflow hidden
						.opt-check
							display none
						&:hover
							border-color #3D5EFF
							color #3D5EFF
						&.s-normal
							&:hover
								border-color #38a169
								color #38a169
						&.s-defect
							&:hover
								border-color #e53e3e
								color #e53e3e
						&.z-alive
							border-color #3D5EFF
							color #3D5EFF
							background #fff
							font-weight 600
							.opt-check
								display inline
								position absolute
								bottom -1px
								right -1px
								width 0
								height 0
								border-style solid
								border-width 0 0 18px 20px
								border-color transparent transparent #3D5EFF transparent
								&::after
									content '\e63f'
									position absolute
									bottom -16px
									right 2px
									font-size 6px
									color #fff
									line-height 1
						&.z-normal
							border-color #38a169
							color #38a169
							background #fff
							font-weight 600
							.opt-check
								display inline
								position absolute
								bottom -1px
								right -1px
								width 0
								height 0
								border-style solid
								border-width 0 0 18px 18px
								border-color transparent transparent #38a169 transparent
								&::after
									content '\e66f'
									position absolute
									bottom -16px
									right 2px
									font-size 6px
									color #fff
									line-height 1
						&.z-defect
							border-color #e53e3e
							color #e53e3e
							background #fff
							font-weight 600
							.opt-check
								display inline
								position absolute
								bottom -1px
								right -1px
								width 0
								height 0
								border-style solid
								border-width 0 0 18px 18px
								border-color transparent transparent #e53e3e transparent
								&::after
									content '\e66f'
									position absolute
									bottom -16px
									right 2px
									font-size 6px
									color #fff
									line-height 1
					.c-input,
					.c-datetime
						width 260px
	.preview-side
		width 430px
		flex-shrink 0
		background #fff
		overflow hidden
		display flex
		flex-direction column
		.preview-title
			margin 0
			padding 0 18px
			font-size 15px
			font-weight 600
			color #1d3557
			line-height 46px
			background: #F9F9F9;
		.preview-tabs
			display flex
			background #F9F9F9
			border-bottom 1px solid #edf0f5
			.preview-tab
				flex 1
				text-align center
				font-size 13px
				color #8a94a6
				line-height 36px
				cursor pointer
				transition all .2s
				&.z-alive
					color #3D5EFF
					font-weight 600
					background #fff
					border-bottom 2px solid #3D5EFF
		.preview-list
			flex 1
			padding 12px 20px
			.preview-item
				display flex
				justify-content space-between
				align-items baseline
				padding 8px 18px
				font-size 13px
				line-height 20px
				cursor pointer
				border-radius 6px
				transition background .15s
				&:hover
					background #f5f8ff
				label
					color #5a6b7f
					flex-shrink 0
				span
					flex 1
					color #1a1a1a
					text-align right
					word-break break-all
					font-weight 400
					&.z-empty
						color #bbb
					&.z-normal
						color #38a169
						font-weight 600
					&.z-defect
						color #e53e3e
						font-weight 600
				.preview-ref-btn
					flex-shrink 0
					margin-left 8px
					padding 0 10px
					line-height 20px
					font-size 12px
					font-style normal
					color #3D5EFF
					border 1px solid #c9d4ff
					border-radius 10px
					cursor pointer
					transition all .2s
					&:hover
						color #fff
						background #3D5EFF
						border-color #3D5EFF
		.preview-empty
			padding 24px 18px
			font-size 12px
			color #bbb
			text-align center
/* 映射配置弹窗：质检项摘要信息条（弹窗挂载在 body 下，样式规则必须顶格书写才能命中弹窗内元素） */
.ref-config-body
	padding 18px 20px
	.ref-config-item
		display flex
		align-items baseline
		gap 8px
		margin-bottom 14px
		padding 10px 14px
		background #f5f8ff
		border-left 3px solid #3D5EFF
		border-radius 4px
		label
			flex-shrink 0
			font-size 13px
			color #5a6b7f
		span
			font-size 14px
			font-weight 600
			color #1d3557
/* 映射配置弹窗：原生3列表格（顶格规则，避免嵌在 .edit-body 内编译出前缀导致弹窗内不命中） */
.ref-config-table
	width 100%
	border-collapse collapse
	table-layout fixed
	border 1px solid #e4e9f0
	border-radius 6px
	th
		padding 10px 14px
		background #f7f9fc
		font-size 12px
		font-weight 600
		color #5a6b7f
		text-align left
		white-space nowrap
		border-bottom 1px solid #e4e9f0
		&:nth-child(1)
			width 34%
		&:nth-child(2)
			width 30%
	td
		padding 11px 14px
		font-size 13px
		color #2d3748
		text-align left
		vertical-align middle
		border-bottom 1px solid #eef1f6
		word-break break-all
	tbody tr:last-child td
		border-bottom none
	tbody tr:hover
		background #f8faff
.ref-config-empty
	padding 36px 0
	font-size 13px
	color #b0b7c3
	text-align center
.ref-config-off
	display inline-block
	margin-left 6px
	padding 0 6px
	font-size 11px
	line-height 16px
	font-style normal
	color #fa8c16
	background #fff7e6
	border-radius 8px
	vertical-align 1px
.factory-list
	.factory-item
		margin-bottom 10px
		label
			flex-shrink 0
			width 90px
			font-size 13px
			color #5a6b7f
		.factory-value
			flex 1
			font-size 13px
			color #2d3748
			font-weight 500
.dialog-footer
	margin-top 18px
	padding-top 14px
	border-top 1px solid #edf2f7
	text-align right
.channel-tip
	margin 0 0 14px
	font-size 13px
	color #7a8ea0
.channel-list
	.channel-item
		display flex
		justify-content space-between
		align-items center
		padding 12px 16px
		margin-bottom 8px
		border 1px solid #e2e8f0
		border-radius 8px
		cursor pointer
		transition all .2s
		.channel-name
			font-size 13px
			color #2d3748
			font-weight 500
		.channel-fee
			font-size 12px
			color #8a9bb0
			background #f7fafc
			padding 2px 8px
			border-radius 10px
		&:hover
			border-color #90cdf4
			background #f7faff
		&.z-alive
			border-color #1890ff
			background #e6f4ff
			.channel-name
				color #1890ff
.query-loading
	display flex
	flex-direction column
	align-items center
	justify-content center
	padding 48px 0
	gap 14px
	font-size 14px
	color #7a8ea0
	.loading-spinner
		display inline-block
		width 24px
		height 24px
		border 2.5px solid #e2e8f0
		border-top-color #1890ff
		border-radius 50%
		animation spin .7s linear infinite
@keyframes spin
	to
		transform rotate(360deg)
</style>